import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import FitAssistantSlice from '../Slices/FitAssistantSlice.ts';
import MatchingProductsSlice from '../Slices/MatchingProductsSlice.ts';
import ProductDetailSlice from '../Slices/ProductDetailSlice.ts';

const store = configureStore({
  reducer: {
    FitAssistant: FitAssistantSlice,
    MatchingProducts: MatchingProductsSlice,
    ProductDetail: ProductDetailSlice,
  },
  devTools: {
    name: `Fit Assistant - ${document.title} (${window.location.href})`,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

export default store;
